import React, { useMemo } from 'react';

import { useCurrentUser } from 'Auth';

import { useLoadPartnerAudience } from 'scenes/CustomAudiences/PartnerAudiences/data';
import {
  useBatchCreatePartnerAudience,
  useUpdatePA,
} from 'scenes/CustomAudiences/PartnerAudiences/data/mutations';

import PartnerAudienceForm from './PartnerAudienceForm';
import SinglePartnerAudienceForm from './SinglePartnerAudienceForm';
import { OWNER, PARENT_AUDIENCE } from './constants';

export { PARENT_AUDIENCE };

const EMPTY_PARENT_INITIAL = {};
export const PartnerAudienceFormCreate = ({
  initialValues: parentInitialValues = EMPTY_PARENT_INITIAL,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [batchCreatePartnerAudiences, { isLoading: isCreating }] =
    useBatchCreatePartnerAudience();

  const user = useCurrentUser();

  const initialValues = useMemo(
    () => ({
      ...parentInitialValues,
      [OWNER]: user.id,
    }),
    [parentInitialValues, user]
  );

  const handleSubmit = async ({ partnerAudiences, ...other }) => {
    let data = partnerAudiences.map((partnerAudience) => ({
      ...partnerAudience,
      ...other,
    }));

    await batchCreatePartnerAudiences(data);

    onSubmit();
  };

  return (
    <PartnerAudienceForm
      title={'Add Partner Audience'}
      loading={isCreating}
      onClose={onClose}
      onExited={onExited}
      open={open}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    />
  );
};

export const PartnerAudienceFormEdit = ({ onClose, onExited, open, id }) => {
  const { data, isLoading } = useLoadPartnerAudience({ id });
  const [updatedPA] = useUpdatePA();

  const handleSubmit = async (values) => {
    updatedPA(values);
    onClose();
  };

  return (
    <SinglePartnerAudienceForm
      title={'Edit Partner Audience'}
      loading={isLoading}
      onClose={onClose}
      onExited={onExited}
      open={open}
      initialValues={data}
      onSubmit={handleSubmit}
    />
  );
};
